import { render, staticRenderFns } from "./parametro.vue?vue&type=template&id=2f0e2c54"
import script from "./parametro.vue?vue&type=script&lang=js"
export * from "./parametro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports